/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandUnsplash = createReactComponent("outline", "brand-unsplash", "IconBrandUnsplash", [["path", { "d": "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z", "key": "svg-0" }]]);

export { IconBrandUnsplash as default };
//# sourceMappingURL=IconBrandUnsplash.mjs.map
